import styled from "styled-components";
import { Font, Color } from "@styles/constants";
import { HeadingDisplayCSS } from "@styles/typography";

export const StyledCounter = styled.div`
  ${HeadingDisplayCSS}
  color: ${Color.white};
`;
